<template>
    <v-app>
      <Drawer current_item="menu_customer"></Drawer>
      
      <v-main class="ml-6 mr-6">
        <v-card
              class="mx-auto mt-4 mr-6 pa-6"
              outlined
            >
                <v-card-title> {{ $t('customer_title') }}</v-card-title>
                <v-divider></v-divider>
                <v-data-table
                    :headers="headers"
                    :items-per-page="10"
                    :items="items"
                >
                    <template v-slot:top >
                        <v-toolbar flat color="white">
                                <v-spacer></v-spacer>
                                <DlgCustomer ref="dlgCustomer" @onCloseDialog="onCloseDialog"></DlgCustomer>
                        </v-toolbar>
                    </template>
                    <template  v-slot:[`item.action`]="{ item }">
                        <v-icon
                            small
                            class="mr-2"
                            @click="editItem(item)"
                        >
                            edit
                        </v-icon>
                        <v-icon
                            small
                            @click="deleteItem(item)"
                        >
                            delete
                        </v-icon>
                    </template>
                </v-data-table>
            </v-card>
      </v-main>
      <v-snackbar
            v-model="snackbar"
            timeout="2000"
     >
      {{ message }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="blue"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
    </v-app>
</template>

<script>
import Drawer from '@/components/Drawer.vue'
import config from '@/../config.js'
import DlgCustomer from './DlgCustomer'
import axios from 'axios';
import Staff from '@/model/instance/Staff.js'

export default {
  name: 'Customer',
  computed: {
    headers() {
      return [
            {text: this.$t('customer_name'), value: 'customer_name', width: '25%'},
            {text: 'จุดบริการ', value: 'station_name', width: '20%'},
            {text: this.$t('email'), value: 'email1', width: '15%'},
            {text: this.$t('customer_phone'), value: 'phone_number', width: '15%'},
            {text: this.$t('tax_id'), value: 'tax_id', width: '15%'},
            {text: 'Actions', value: 'action', sortable: false}
        ]
    }
  },
  components: {
      Drawer,
      DlgCustomer
  },
  data: () => ({
      items: [],
      editedIndex: -1,
      snackbar: false,
      message: ''
  }),
  methods: {
      loadCustomer() {
        var que = this.$store.commit('addLoading')
        axios.get(
            config.api.url.manage.customer.list,
            { headers: Staff.getTokenHeader()}
        ).then(rs => {
            this.$store.commit('finishLoading',que)
            this.items = rs.data;
        })
        .catch(error => {
            this.$store.commit('finishLoading',que)
            this.$router.push({name:'Error',params:error}) 
        });
      },
      editItem(item) {
          this.editedIndex = this.items.indexOf(item);
          this.$refs.dlgCustomer.show(Object.assign({}, item));
      },
      deleteItem(item) {
          var que = this.$store.commit('addLoading')
          axios.get(
            config.api.url.manage.customer.delete + item.customer_id,
            { headers: Staff.getTokenHeader()}
        ).then(() => {
            this.$store.commit('finishLoading',que)
            this.editedIndex = this.items.indexOf(item);
            this.items.splice(this.editedIndex, 1);
            this.editedIndex = -1;
        })
      },
      onCloseDialog(isSuccess) {
          if (isSuccess == true) {
              this.loadCustomer();
              this.message = this.$t('save_success');
              this.snackbar = true;
          }
          
          this.editedIndex = -1;
      }
  },
  mounted() {
      this.loadCustomer();
  }
}
</script>